.box {
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  background: #fff;
  height: 36px;
  width: 100%;
  max-width: 140px;
  overflow: hidden;
}

.box.sm { height: 30px; max-width: 110px; }
.box.lg { height: 44px; max-width: 160px; }

.btn {
  flex: 0 0 auto;
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 0 6px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-ink);
}

.btn:disabled { color: rgba(0, 0, 0, 0.25); cursor: not-allowed; }

.input {
  flex: 1;
  border: 0;
  outline: none;
  text-align: center;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  width: 0;
  min-width: 0;
  padding: 0 4px;
  -moz-appearance: textfield;
}

.input::-webkit-outer-spin-button,
.input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }

.disabled { opacity: 0.55; }

.active {
  border-color: var(--color-ember);
  box-shadow: 0 0 0 2px rgba(243, 154, 46, 0.18);
}
